<template>
  <router-view />
</template>
<script>
export default {
  name: 'SplashLayout',
}
</script>

